import { z } from 'zod/v4';

export const copiedPanelSourceSchema = z.object({
  /** Type of the resource the panel was copied from (e.g., 'dashboard') */
  type: z.string(),
  /** Slug of the resource the panel was copied from (e.g., 'example-dashboard') */
  slug: z.string().optional(),
  /** Hostname where the panel was copied */
  hostname: z.string().optional(),
});

export type CopiedPanelSource = z.TypeOf<typeof copiedPanelSourceSchema>;
